import { useRef } from "react";
import classNames from "classnames";
import { useHotkeys } from "react-hotkeys-hook";
import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "../../IconButton";

export interface BookmarksPopoverButtonProps {
  isOpen?: boolean;
}

export const BookmarksPopoverButton = ({
  isOpen = false,
}: BookmarksPopoverButtonProps) => {
  const hasBookmarksButtonRef = useRef<HTMLButtonElement | null>(null);

  useHotkeys(
    "alt+b",
    () => {
      hasBookmarksButtonRef.current?.click();
    },
    [hasBookmarksButtonRef],
  );

  return (
    <div className="relative">
      <TippyV2 interactive={false} content={t("header_v3.bookmarks")}>
        <IconButton
          name="20-flux-bookmark"
          buttonSize={36}
          iconSize={20}
          className={classNames(
            "hover:!bg-c-header-hover focus:!bg-c-header-hover !text-c-header hover:!text-c-header-active focus:!text-c-header-active !rounded-md p-1.5 duration-150",
            {
              "!bg-c-header-active !text-c-header-active": isOpen,
            },
          )}
          iconClassName={classNames("!text-inherit !transition-none")}
          ariaLabel={t("header_v3.bookmarks")}
          ref={hasBookmarksButtonRef}
          dataTestId="bookmarks-popover-button"
        />
      </TippyV2>
    </div>
  );
};
